import { Component, Input, OnInit } from '@angular/core';
import { Banner } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { SmarterSellerMilestones } from 'src/app/core/model/promotion/MilestoneSmartSeller';
import { PromotionStoreService } from 'src/app/core/store/promotion-store.service';

@UntilDestroy()
@Component({
  selector: 'app-milestone-banner',
  templateUrl: './milestone-banner.component.html',
  styleUrls: ['./milestone-banner.component.scss'],
})
export class MilestoneBannerComponent implements OnInit {
  @Input() banner: Banner | null;

  milestoneData: SmarterSellerMilestones;

  barPixel = 122.8;
  barWidth = 0;
  performanceCompletedLength = 0;
  currentPerformance: any;

  milestoneBarImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Promotions/SmarterSeller/Milestones/Milestones.png?versionId=.lyreTbXF7Sr44HB5C68MvW5FQl5s0Ax';

  constructor(private promotionStore: PromotionStoreService) {}

  ngOnInit(): void {
    this.promotionStore.smarterSellerMilestones$
      .pipe(untilDestroyed(this), filter(Boolean))
      .subscribe((smartSellermilestones: SmarterSellerMilestones | null) => {
        if (smartSellermilestones) {
          this.milestoneData = smartSellermilestones;
          this.setTrack();
        }
      });
  }

  private calculateBarWidth(completedBar: number): number {
    let barWidth = 0;

    for (let i = 1; i <= completedBar; i += 1) {
      if (i === 2 || i === 3) {
        barWidth += this.barPixel - 4;
      } else {
        barWidth += this.barPixel;
      }
    }

    return barWidth;
  }

  private setTrack(): void {
    const performanceCompleted = this.milestoneData.milestones.filter((m) => m.isLevelCompleted === true);

    this.performanceCompletedLength = performanceCompleted.length - 1;

    if (performanceCompleted) {
      this.barWidth = this.calculateBarWidth(this.performanceCompletedLength);
      this.currentPerformance = performanceCompleted.pop();
    }
  }
}
